import React from 'react';
import { SunIcon, MoonIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';
import type { ThemeMode } from '@packages/global';
import type { ThemeToggleProps } from './types';

const options: { mode: ThemeMode; icon: React.ElementType }[] = [
  { mode: 'light', icon: SunIcon },
  { mode: 'dark', icon: MoonIcon },
  { mode: 'system', icon: ComputerDesktopIcon },
];

const ThemeToggle: React.FC<ThemeToggleProps> = ({
  compact = false,
  mode,
  onModeChange,
  labels,
  compactClassName = 'w-full flex items-center justify-center p-2 rounded-lg text-gray-400 hover:text-gray-50 hover:bg-bg-elevated transition-all duration-200 cursor-pointer',
  containerClassName = 'flex items-center gap-1 p-1 rounded-lg bg-bg-elevated',
  activeClassName = 'bg-bg-surface text-gray-50 shadow-sm',
  inactiveClassName = 'text-gray-400 hover:text-gray-200',
}) => {
  if (compact) {
    const current = options.find((option) => option.mode === mode) ?? options[1];
    const next = options[(options.indexOf(current) + 1) % options.length];
    const Icon = current.icon;

    return (
      <button
        onClick={() => onModeChange(next.mode)}
        title={`当前：${labels[current.mode]}，点击切换为${labels[next.mode]}`}
        className={compactClassName}
      >
        <Icon className="w-5 h-5" />
      </button>
    );
  }

  return (
    <div className={containerClassName}>
      {options.map(({ mode: nextMode, icon: Icon }) => (
        <button
          key={nextMode}
          onClick={() => onModeChange(nextMode)}
          title={labels[nextMode]}
          className={`flex-1 flex items-center justify-center gap-1.5 px-2 py-1.5 rounded-md text-xs font-medium transition-all duration-200 cursor-pointer ${mode === nextMode ? activeClassName : inactiveClassName}`}
        >
          <Icon className="w-3.5 h-3.5 flex-shrink-0" />
          <span>{labels[nextMode]}</span>
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle;
